/**
 * Convert array index to "position" in % such that last index corresponds to 100%.
 * @param arr - array.
 * @param index - array index
 * @returns percentage
 */
export function getPositionFromIndex(arr, index) {
    const percentagePerItem = 100 / arr.length;
    const right = percentagePerItem * (index + 1);
    return Math.min(right, 100);
}
/**
 * Find element in `list` that is closest to `value` with respect to `distance`.
 * @param value - the needle
 * @param list - the haystack, a *sorted* array
 * @param distance - a function that returns the distance between `value` and an object
 *     in `list`
 * @param offset - base index of list (for recursive steps)
 * @returns index of element closest to `value` or `-1` if `list` is empty
 */
export function findClosestIndex(value, list, distance, offset = 0) {
    if (list.length === 0) {
        return -1;
    }
    if (list.length === 1) {
        return offset;
    }
    if (list.length === 2) {
        if (distance(value, list[0]) < distance(value, list[1])) {
            return offset;
        }
        else {
            return offset + 1;
        }
    }
    const middle = Math.floor(list.length / 2);
    if (distance(value, list[middle]) < distance(value, list[middle + 1])) {
        return findClosestIndex(value, list.slice(0, middle + 1), distance, offset);
    }
    else {
        const sliceIndex = middle + 1;
        const offset_new = offset + sliceIndex;
        return findClosestIndex(value, list.slice(sliceIndex), distance, offset_new);
    }
}
//# sourceMappingURL=array.js.map